import styled from "styled-components";
import {styledByTheme} from "../../../../../themes/architecture/styled-by-theme";

export const TitleContainerDefaultBox = styled.div`
  cursor: pointer;
`;

const TitleContainerSIBox = styled(TitleContainerDefaultBox)`
    padding-left: 10px
`;

export const TitleContainerBox = styledByTheme(TitleContainerDefaultBox)
    .forSICis(TitleContainerSIBox)
    .forSI(TitleContainerSIBox)
    .apply();